export default __webpack_public_path__ + "static/media/bp-header-tablet.040c75a1.png";